import * as React from 'react';
import { TopToolbar, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Moment from 'moment';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Box from '@material-ui/core/Box';
//import PostPagination from './PostPagination';

const cardStyle = {
  width: 300,
  minHeight: 300,
  margin: '0.5em',
  display: 'inline-block',
  verticalAlign: 'top'
};


const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      // width: '500',
      //margin:'0 auto',

    },

    gridTitle: {
      backgroundColor: "#ddd"
    },

    paper: {
      padding: theme.spacing(1),
      margin: 10,
      // maxWidth: 1000,
      // width: '100%',
      backgroundColor: '#F7F7F7',
      // display: 'flex',
      // justifyContent:'center'
    },
    image: {
      //width: 300,
      //height: 300,
      // margin: '0 auto',
    },
    img: {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  }),
);

const PostPagination = () =>
{
  const { page, perPage, total, setPage } = useListContext();
  const nbPages = Math.ceil(total / perPage) || 1;
  return (
    nbPages > 1 &&
    <Toolbar>
      {page > 1 &&
        <Button color="primary" key="prev" onClick={() => setPage(page - 1)}>
          <ChevronLeft />
          Prev
        </Button>
      }
      {page !== nbPages &&
        <Button color="primary" key="next" onClick={() => setPage(page + 1)}>
          Next
          <ChevronRight />
        </Button>
      }
    </Toolbar>
  );
}

const options = {
  replace: domNode =>
  {
    if (domNode.attribs && domNode.name === 'main')
    {
      const props = attributesToProps(domNode.attribs);
      return <div {...props} />;
    }
  }
};

const ListActions = (props) => (
  <TopToolbar>

  </TopToolbar>
);



const CommentGrid = () =>
{
  const classes = useStyles();
  const { ids, data, basePath } = useListContext();

  return (
    <div className={classes.root}>
      {ids.map(id => (

        // data.map(id =>
        <Paper className={classes.paper} key={data[id].id}>
          <Grid container spacing={12}>

            <Grid item xs="0.5">
              <ContactSupportIcon />
            </Grid>
            <Grid item xs>
              <Box fontWeight="fontWeightBold" textAlign="left">
                {data[id].name}
              </Box>
            </Grid>

            <Grid item xs={12}>

              <Typography variant="body2" gutterBottom>
                {
                  parse(data[id].text, options)}

              </Typography>

            </Grid>
          </Grid>
        </Paper>
        //)}
      ))}

    </div>
  );
};

export const FaqList = (props) => (
  <List title="All comments" {...props} pagination={false} actions={<ListActions />}>
    <CommentGrid id='SS' />
  </List>
);